<template>
	<div class="main-content" id="panel">
        <vue-form :state="formstate" @submit.prevent="create()">
    		<!-- Topnav -->
    		<nav :class="classNavbar">
    			<div class="container-fluid">
    				<div class="collapse navbar-collapse" id="navbarSupportedContent">
    					<!-- Search form -->
    					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
    						<ol class="breadcrumb breadcrumb-links">
    							<li class="breadcrumb-item"><router-link to="/"><strong>Inicio</strong></router-link></li>
    							<li class="breadcrumb-item active" aria-current="page"> </li>
    						</ol>
    					</nav>
    				</div>
    			</div>
    		</nav>
    		<!-- Header -->
    		<div class="header  d-flex align-items-center">
    			<!-- Mask -->
    			<span class="mask bg-gradient-default opacity-1"></span>
    			<!-- Header container -->
    			<div class="container-fluid  align-items-center">
    				<div class="row">
    					<div class="col-lg-7 col-md-10 mt-4">
    						<h1 class="display-3">Registrarme</h1>

    					</div>
    				</div>
    			</div>
    		</div>
    		<!-- Page content -->
        	<div class="container-fluid col-11">
        		<div class="card mb-4">
        			<!-- Card header -->
        			<div class="card-header">
        				<p>Por favor llene el siguiente formulario</p>
        			</div>
        			<!-- Card body -->
        			<div class="card-body">
        				<!-- Form groups used in grid -->
        				<div class="row">
        					<div class="col-md-4">
        						<div class="form-group">
        							<label class="form-control-label" for="example3cols1Input">Genero:</label>
        							<div class="custom-control custom-radio mb-3">
        								<div class="custom-control custom-radio ">
        									<input name="custom-radio-1" class="custom-control-input" id="customRadio6" checked="" type="radio" value="1">
        									<label class="custom-control-label" for="customRadio6">Masculino</label>
        								</div>
        								<div class="custom-control custom-radio ">
        									<input name="custom-radio-1" class="custom-control-input" id="customRadio5" type="radio" value="2">
        									<label class="custom-control-label" for="customRadio5">Femenino</label>
        								</div>
        							</div>
        						</div>
        					</div>
        					<div class="col-md-4">
            						<div class="form-group">
                                        <validate tag="div">
                							<label class="form-control-label" for="nombres">Nombre*</label>
                							<input type="text" class="form-control" id="nombres" v-model="model.nombre" name="nombres" placeholder="Escribe tu nombre" required>
                                            <field-messages name="nombres" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">El nombre es requerido</div>
                                            </field-messages>
                                        </validate>
            						</div>
        					</div>
        					<div class="col-md-4">
        						<div class="form-group">
                                    <validate tag="div">
            							<label class="form-control-label" for="apellidos">Apellidos*</label>
            							<input type="text" class="form-control" name="apellidos" id="apellidos" v-model="model.apellidos" placeholder="Apellidos" required>
                                        <field-messages name="apellidos" show="$invalid && $submitted" class="text-danger">
                                            <div slot="required">Los apellidos son requeridos</div>
                                        </field-messages>
                                    </validate>
        						</div>
        					</div>
        				</div>
        				<div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <validate tag="div">
                                        <label class="form-control-label" for="exampleFormControlSelect1">Empresa/Escuela/Organización</label>
                                        <b-form-select v-model="model.id_cliente" :options="clients" id="id_cliente" name="id_cliente" value-field="id" text-field="nombre" required></b-form-select>
                                        <field-messages name="id_cliente" show="$invalid && $submitted" class="text-danger">
                                            <div slot="required">Este campo es requerido</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
        					<div class="col-md-4">
        						<label class="form-control-label" for="fecha_nacimiento">Fecha de nacimiento:</label>
                                <flat-pickr class="form-control" v-model="model.fecha_nacimiento"></flat-pickr>
        					</div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <validate tag="div">
                                        <label class="form-control-label" for="id_idioma">Idioma*</label>
                                        <b-form-select v-model="model.id_idioma" :options="idiomas" id="id_idioma" name="id_idioma" value-field="id" text-field="nombre" required></b-form-select>
                                        <field-messages name="id_idioma" show="$invalid && $submitted" class="text-danger">
                                                <div slot="required">El idioma es requerido</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
        				</div>
        				<div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-control-label" for="id_pais">País</label>
                                    <b-form-select v-model="model.id_pais" :options="paises" id="id_pais" value-field="id" text-field="nombre" @change="getEstados"></b-form-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-control-label" for="id_estado">Estado o provincia</label>
                                    <b-form-select v-model="model.id_estado" :options="estados" id="id_estado" value-field="id" text-field="nombre" @change="getCiudades"></b-form-select>
                                </div>
                            </div>
        					<div class="col-md-4">
        						<div class="form-group">
        							<label class="form-control-label" for="example3cols2Input">Ciudad</label>
                                    <b-form-select v-model="model.id_ciudad" :options="ciudades" id="id_ciudad" value-field="id" text-field="nombre"></b-form-select>
        						</div>
        					</div>
        				</div>
        				<div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-control-label" for="cp">Código postal</label>
                                    <input type="text" class="form-control" v-model="model.cp" id="cp" placeholder="00000">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-control-label" for="telefono">Número de contacto</label>
                                    <input type="text" class="form-control" id="telefono" v-model="model.telefono" placeholder="10 dígitos">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-control-label" for="id_zona_horaria">Zona horaria</label>
                                    <b-form-select v-model="model.id_zona_horaria" :options="zonashorarias" id="id_zona_horaria" value-field="id" text-field="nombre"></b-form-select>
                                </div>
                            </div>
        				</div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <validate tag="div">
                                        <label class="form-control-label" for="email">Correo electrónico*</label>
                                        <input class="form-control" id="email" name="email" v-model="model.email" placeholder="Dirección de correo válida" type="email" required >
                                        <field-messages name="email" show="$invalid && $submitted" class="text-danger">
                                            <div slot="required">El correo electrónico es requerido</div>
                                            <div slot="email">El correo electrónico no es válido</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <validate tag="div">
                                        <label class="form-control-label" for="password">Contraseña*</label><div class="input-group input-group-merge">
                                            <input class="form-control" id="password" name="password" v-model="model.password" placeholder="Contraseña" type="password" required minlength="8">
                                            <div class="input-group-append">
                                                <span class="input-group-text"><i class="fas fa-eye"></i></span>
                                            </div>
                                        </div>
                                        <field-messages name="password" show="$invalid && $submitted" class="text-danger">
                                            <div slot="required">La contraseña es requerida</div>
                                            <div slot="minlength">La contraseña debe de tener mínimo 8 caracteres</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <validate tag="div">
                                        <label class="form-control-label" for="tipo_usuario_pro">Tipo de usuario*</label>
                                        <b-form-select v-model="model.tipo_usuario_pro" :options="tipoUsuarios" id="tipo_usuario_pro" name="tipo_usuario_pro" value-field="id" text-field="nombre" required></b-form-select>
                                        <field-messages name="tipo_usuario_pro" show="$invalid && $submitted" class="text-danger">
                                            <div slot="required">El tipo de usuario es requerido</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="model.tipo_usuario_pro == 2">
                            <div class="col-md-4">

                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <validate tag="div">
                                        <label class="form-control-label" for="codigo_docente">Código de acceso*</label>
                                        <input class="form-control" id="codigo_docente" name="codigo_docente" v-model="model.codigo_docente" placeholder="Ingresa tu código de acceso" type="text" required >
                                        <field-messages name="codigo_docente" show="$invalid && $submitted" class="text-danger">
                                            <div slot="required">El código es requerido</div>
                                        </field-messages>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-md-4">

                            </div>
                        </div>
        				<div class=" mx-0 d-block"><button class="btn btn-primary center" type="submit">Registrarme</button></div>
        			</div>
        		</div>
        		<footer class="footer pt-0" id="footer">
    				<div class="row align-items-center justify-content-lg-between">
    					<div class="col-lg-6">
    						<div class="copyright text-center text-lg-left text-muted">
    							&copy; 2020 <a href="http://etciberoamerica.com/" class="font-weight-bold ml-1" target="_blank">ETC Iberoamérica</a>
    						</div>
    					</div>
    					<div class="col-lg-6">
    						<ul class="nav nav-footer justify-content-center justify-content-lg-end">
    							<li class="nav-item">
    								<a href="#" class="nav-link" target="_blank">eThinking</a>
    							</li>
    							<li class="nav-item">
    								<a href="#" class="nav-link" target="_blank">Aviso de privacidad</a>
    							</li>
    							<li class="nav-item">
    								<a href="#" class="nav-link" target="_blank">Contacto</a>
    							</li>
    							
    						</ul>
    					</div>
    				</div>
    			</footer>
    		</div>
        </vue-form>
	</div>
</template>
<script>
    import options from '../validations/validations.js'
    Vue.use(VueForm, options)
	export default {
		name: 'Register',
        components: {
            flatPickr
        },
        data() {
            return {
                paises: [],
                idiomas: [],
                estados: [],
                ciudades: [],
                zonashorarias: [],
                clients: [],
                tipoUsuarios: [{id: 1, nombre: 'Estudiante'}, {id: 2, nombre: 'Maestro'}],
                formstate: {},
                classNavbar: 'navbar navbar-top navbar-expand navbar-light bg-gradient-light border-bottom',
                model: {
                    nombre: '',
                    apellidos: '',
                    email: '',
                    password: '',
                    id_pais: '',
                    id_idioma: '',
                    id_estado: '',
                    id_ciudad: '',
                    id_cliente: "0",
                    id_zona_horaria: '',
                    fecha_nacimiento: '',
                    tipo_usuario: {id: '4'},
                    tipo_usuario_pro: '',
                    codigo_docente: '',
                },
            }
        },
        methods: {
            async create() {
                if (this.formstate.$invalid) {
                    return;
                } else {
                    this.model.id_idioma = {id: this.model.id_idioma}
                    this.model.id_pais = {id: this.model.id_pais}
                    this.model.id_estado = {id: this.model.id_estado}
                    this.model.id_ciudad = {id: this.model.id_ciudad}
                    this.model.id_zona_horaria = {id: this.model.id_zona_horaria}
                    this.model.id_cliente = {id: this.model.id_cliente}
                    await this.register('api/usuarios', this.model, '/', '', null, 0, 1, null)
                }
            }
        },
		async mounted() {
            this.hostname = hostname
            if(hostname == 'seducoahuila.etciberoamerica.com' || hostname == 'iproedomex.etciberoamerica.com' || hostname == 'ctm.etciberoamerica.com') {
				this.classNavbar = 'navbar navbar-top navbar-expand navbar-light bg-purple border-bottom'
			}
            this.openLoading()
			await this.getPaises()
            await this.getIdiomas()
            await this.getZonasHorarias()
            await this.getClients()
            Swal.close()
		}
	}
</script>